<script lang="ts">
  import PICCCLogo from 'images/gateways/piccc/logo-piccc.png'
</script>

<a href="/">
  <img src={PICCCLogo} />
  <h1 class="sr-only">{window.gettext('Pacific Islands Climate Change Cooperative Planning Atlas')}</h1>
  <div aria-hidden="true" class="title">
    <h1 class="logoText inlineMiddle">
      {window.gettext('PACIFIC ISLANDS')}
      <br />
      {window.gettext('CLIMATE CHANGE COOPERATIVE')}
    </h1>
    <h2>{window.gettext('PLANNING ATLAS')}</h2>
  </div>
</a>

<style lang="scss">
  a {
    display: flex;
    text-decoration: none;

    img {
      margin: 10px 4px 0 10px;
      width: 76px;
      height: 70px;
    }

    .title {
      margin-top: 12px;
      line-height: 24px;

      h1 {
        color: white;
        font-size: $font-size-2;
      }

      h2 {
        color: $secondary-color;
        font-weight: bold;
        font-size: $font-size-0-1;
        font-style: italic;
      }
    }

    &:hover {
      text-decoration: none;
    }
  }
</style>
